import Cgl from 'Cgl';

const CONTEXT = "@grid/dragcontext";

const getDistance = (p1, p2) => Math.sqrt((p2.X - p1.X) ** 2 + (p2.Y - p1.Y) ** 2);

function handleDrag(el, binding) {

    let _layoutMan = binding.value;
    let _cloneNode = null;
    let _cloneNodeInitialBoundary = null;
    let _point = null;

    const _createDragElement = () => {

        const _divEl = document.createElement("div");
        const _selectedList = _layoutMan.GetSelectedList();

        let _minLeft = Infinity,
            _minTop = Infinity,
            _maxRight = -Infinity,
            _maxBottom = -Infinity;

        _selectedList.forEach(config => {

            const _boundary = config.GetBoundary();
            _minLeft = Math.min(_boundary.Left, _minLeft);
            _minTop = Math.min(_boundary.Top, _minTop);
            _maxRight = Math.max(_boundary.Right, _maxRight);
            _maxBottom = Math.max(_boundary.Bottom, _maxBottom);

        });

        Object.assign(_divEl.style, {
            position: "absolute",
            left: _minLeft + "px",
            top: _minTop + "px",
            width: _maxRight - _minLeft + "px",
            height: _maxBottom - _minTop + "px"
        });

        _selectedList.forEach(config => {

            const _boundary = config.GetBoundary();
            
            const _el = config.VueComponent?.$el?.cloneNode(true);

            if (!_el) {
                return;
            }

            Object.assign(_el.style, {
                left: _boundary.Left - _minLeft,
                top: _boundary.Top - _minTop
            });

            _divEl.appendChild(_el);

        });


        return _divEl;
    };
    
    const _mousemove = Cgl.Func.PreventRepeatExec(e => {
        
        let _currentPoint = { X: e.pageX, Y: e.pageY };
    
        // 大于10像素的时候时候才算开始拖拽
        if (!_cloneNode && getDistance(_point, _currentPoint) > 10) {
            _cloneNode = _createDragElement();
            _cloneNodeInitialBoundary = _cloneNode.getBoundingClientRect();
            el.appendChild(_cloneNode);
        }

        if (_cloneNode) {

            // 拖拽节点
            Object.assign(_cloneNode.style, {
                left: _cloneNodeInitialBoundary.left + (_currentPoint.X - _point.X) + "px",
                top: _cloneNodeInitialBoundary.top + (_currentPoint.Y - _point.Y) + "px",
                border: "1px solid red",
                pointerEvents: "none"
            });

        }

    }, 0.1);

    const _mouseup = e => {

        if (_cloneNode) {
            e.preventDefault();
            e.stopPropagation();
        }
    
        _cloneNode?.remove();
        _cloneNodeInitialBoundary = _cloneNode = _point = null;
        _layoutMan.Context.delete("DragContext");
        document.removeEventListener("mousemove", _mousemove)
        document.removeEventListener("mouseup", _mouseup);

    };

    const _handle = e => {

        if (!_layoutMan.IsAllowDrag) {
            return;
        }
        
        // 复制节点
        _point = { X: e.pageX, Y: e.pageY };

        _layoutMan.Context.set("DragContext", {
            StartPoint: _layoutMan.Context.get("MousePosition")
        });

        document.addEventListener("mousemove", _mousemove);
        document.addEventListener("mouseup", _mouseup);

    };

    if (!el[CONTEXT]) {
        el[CONTEXT] = {
            removeHandle: _handle
        };
    } else {
        el[CONTEXT].removeHandle = _handle;
    }

    return _handle;
}

export default {
    bind(el, binding, vnode) {
        el.addEventListener("mousedown", handleDrag(el, binding));
    },
    update(el, binding) {
        el.removeEventListener("mousedown", el[CONTEXT].removeHandle);
        el.addEventListener("mousedown", handleDrag(el, binding));
    },
    unding(el, binding) {
        el.removeEventListener("mousedown", el[CONTEXT].removeHandle);
    }
}